export const PROJECTS = [
  {
    key: "sc1",
    image:
      "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=1200&q=80",
    span: "lg:col-span-7 lg:row-span-2",
    height: "h-[320px] sm:h-[400px] lg:h-auto lg:min-h-[520px]",
    hasStat: true,
  },
  {
    key: "sc2",
    image:
      "https://images.unsplash.com/photo-1551434678-e076c223a692?w=900&q=80",
    span: "lg:col-span-5",
    height: "h-[240px] sm:h-[280px] lg:h-[250px]",
  },
  {
    key: "sc3",
    image:
      "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=900&q=80",
    span: "lg:col-span-5",
    height: "h-[240px] sm:h-[280px] lg:h-[250px]",
  },
];